<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="xl"
		:title="modelId > 0 ? 'Edición de destino' : 'Nuevo destino'"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-card no-body>
			<b-tabs
				no-fade
				pills
				card
				small
				vertical
				nav-class="nav-style"
			>
				<b-tab title="General" active>
					<b-form @submit="onSubmit">
						<b-form-row>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="Nombre">
								<b-form-input type="text" size="sm" v-model="modelInfo.name" required />
							</b-form-group>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="Ciudad">
								<b-form-select size="sm" v-model="modelInfo.destinationId" :options="$root.auxVars.destinationsOpts" />
							</b-form-group>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="Es Aeropuerto">
								<b-form-select size="sm" v-model="modelInfo.isAirport" :options="[{value:true,text:'SI'},{value:false,text:'NO'}]" />
							</b-form-group>
						</b-form-row>
						<b-form-row>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="Latitud">
								<b-form-input type="text" size="sm" v-model="modelInfo.latitude"  />
							</b-form-group>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="Longitud">
								<b-form-input type="text" size="sm" v-model="modelInfo.longitude"  />
							</b-form-group>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="Codigo postal">
								<b-form-input type="text" size="sm" v-model="modelInfo.postalCode"  />
							</b-form-group>
						</b-form-row>
						<b-form-row>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="Google place ID">
								<b-form-input :disabled="disabledGpDetail" type="text" size="sm" v-model="modelInfo.googlePlaceId"  />
							</b-form-group>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="IATA">
								<b-form-input type="text" size="sm" v-model="modelInfo.iata"  />
							</b-form-group>
							<b-form-group :disabled="unableEdit" class="col-lg-4" label="ICAO">
								<b-form-input type="text" size="sm" v-model="modelInfo.icao"  />
							</b-form-group>
						</b-form-row>
						<b-form-row>
							<b-form-group :disabled="unableEdit" class="col-lg-6" label="Direccion">
								<b-textarea size="sm" v-model="modelInfo.address" />
							</b-form-group>
						</b-form-row>
						<div class="text-right mt-3">
							<b-button v-if="$hasPermission('place.location.search')" variant="info" @click.prevent="editLocation(modelInfo)" class="mr-3">Seleccionar Ubicación</b-button>
							<b-button :disabled="unableEdit" variant="primary" type="submit">{{modelId>0?'Actualizar':'Guardar'}}</b-button>
						</div>
					</b-form>
				</b-tab>
				<b-tab title="Apuntador a destino"  v-if="$hasPermission('place.referenceToPlace')">
					<p>Algunos destinos de nuestra base de datos se repiten, ya que los nombres de los lugares pueden variar segun el idioma, el sistema y otros factores</p>
					<p>Esta funcion permite asignar un destino repetido al destino que le corresponde para tener un mejor control de reservas</p>
					<p>Al asignar un apuntador a destino, todas las reservas conectadas al destino actual se actualizaran para conectarlas con el destino apuntador, sin embargo el destino original permanece para desplegarlo al cliente.</p>

					<p>Ej. Reserva #1 tiene pickup en "Aeropuerto de Cancun" (Aeropuerto Cancun tiene el ID de sistema #1234)</p>
					<p>En el sistema utilizamos el registro: "Cancun International Airport" con ID #5678</p>
					<p>Para el sistema estos son dos lugares diferentes, para homologar usamos el apuntador para que la Reserva #1 se asigne a "Cancun International Airport"</p>
					<p>Despues de asignar, en el sistema interno veremos a reserva #1 con pickup en "Cancun International Airport"</p>
					<p>y el cliente seguira viendo su pickup en "Aeropuerto de Cancun" ya que fue el que el selecciono en su proceso de reserva.</p>

					<br>
					<b-form @submit.prevent="() => {}">
						<b-form-group label="Destino actual">
							<b-input-group size="sm">
								<b-form-input type="text" size="sm" v-model="modelInfo.referenceToPlace.name" disabled />
								<template v-if="modelInfo.referenceToPlace.id > 0" #append>
									<b-button variant="danger" @click="removePlace"><md-icon icon="delete"></md-icon></b-button>
								</template>
							</b-input-group>
						</b-form-group>
					</b-form>
					<b-form-group label="Buscar destino">
						<vue-typeahead-bootstrap
							showAllResults
							size="sm"
							:disabled="!$hasPermission('place.search')"
							placeholder="Buscar"
							v-model="placeSearch"
							:serializer="place => place.name"
							:data="placesData"
							@hit=" selected => setPlace(selected)"
						>
							<template #suggestion="{ data, htmlText }">
								<span v-html="htmlText"></span><br/><small>{{ data.address }}</small>
							</template>
						</vue-typeahead-bootstrap>
					</b-form-group>
					<b-form-checkbox v-model="updatePlaceReservations">Modificar reservas</b-form-checkbox>
					<div class="text-right">
						<b-button variant="primary" @click="onSubmitPlace">Actualizar</b-button>
					</div>
				</b-tab>
			</b-tabs>
		</b-card>
		<EditLocation ref="editLocation"  :success-callback="updaLocation"/>
	</b-modal>
</template>

<script>
// import FormGroupBox from '../../helpers/FormGroupBox'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import { debounce } from "debounce";
import EditLocation from './editLocation.vue'

export default {
	props: {
		successCallback: {
			type : Function,
			required: false,
			default: () => {}
		},
		mode: String,
		unableEdit: Boolean
	},
	components: { VueTypeaheadBootstrap, EditLocation },
	data(){
		const defaultModelInfo = {
			id:-1,
			name:'',
			destinationId:1,
			isAirport:false,
			latitude:0,
			longitude:0,
			postalCode:'',
			address:'',
			iata:'',
			icao:'',
			referenceToPlace:{id:-1,name:''},
		}
		return {
			updatePlaceReservations:true,
			placesData:[],
			placeSearch:'',
			modelId:-1,
			loading:true,
			placeSearchLoading:false,
			modelInfo:{...defaultModelInfo},
			defaultModelInfo:{...defaultModelInfo},
			currentTab:'general',
		}
	},
	computed: {
		disabledGpDetail() {
			if(this.mode === 'airport'){
				return !this.$hasPermission('airport.gpDetail')
			}else{
				return !this.$hasPermission('place.gpDetail')
			}
		}
	},
	methods:{
		editLocation (model)  {
			this.$refs['editLocation'].loadModel(model, this.modelId > 0);
		},
		fetchModel(){
			if(this.modelId > 0){
				this.$emit('update:unableEdit', this.mode == 'airport' ? !this.$hasPermission('airport.edit') : !this.$hasPermission('place.edit'))
				this.loading = true
				this.$root.api.get(`/places/${this.modelId}`).then((res) => {
					this.modelInfo = {...res.data}
					this.loading = false
				}).catch(this.$root.handleRequestError);
			}else{
				this.modelInfo = {...this.defaultModelInfo}
				this.loading = false
			}
		},
		loadModel(id){
			this.modelId = id
			this.$refs['modal-view'].show()
			this.fetchModel()
		},
		onSubmitPlace(){
			this.$root.api.put(`/places/${this.modelId}/reference-to-place`,{
				referenceToPlaceId : this.modelInfo.referenceToPlace.id>0 ? this.modelInfo.referenceToPlace.id : null,
				updatePlaceReservations:this.updatePlaceReservations,
			}).then((res) => {
				this.$root.showAlert(`Apuntador a destino actualizado, se actualizaron ${res.data.resUpdated} servicios`)
				this.successCallback(res);
			});
		},
		onSubmit(event){
			event.preventDefault();
			if(this.$listeners.submit){
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url:this.modelId > 0 ? `/places/${this.modelId}`: '/places',
				method:this.modelId > 0 ? 'put':'post',
			}
			if(rParams.method == 'get'){
				rParams['params'] = this.modelInfo
			}else{
				rParams['data'] = this.modelInfo
			}
			this.$root.api.request(rParams).then((res) => {
				this.$root.showAlert('OK!')
				this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['destinationsOpts','airportsOpts'],forceRefresh: true})
				if(res.data.id) this.loadModel(res.data.id )
				this.successCallback(res)
			})
			.catch(this.$root.handleRequestError)
			.then(() => {
				this.loading = false;
			})
		},
		searchPlace(term){
			if (term!='') {
				this.placeSearchLoading = true
				this.$root.api.post(`/places/search`,{ term }).then( (res) => {
					this.placesData = res.data
					this.placeSearchLoading = false
				}).catch( err => {
					console.log('Error', err)
				});
			}
		},
		setPlace(selected){
			this.modelInfo.referenceToPlace = {...selected}
		},
		removePlace(){
			this.modelInfo.referenceToPlace = {id:-1,name:''}
		},
		updaLocation (data) {
			// Agregar la informacion recuperada
			this.modelInfo = Object.assign(this.modelInfo, data);
		}
	},
	mounted(){
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['countriesOpts','destinationsOpts']})
	},
	watch : {
		placeSearch: debounce(function(term) { this.searchPlace(term) }, 500),
	}

}
</script>

<style>

</style>
